import React, { Component, Fragment } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { thousandSeparator } from '../../../utils/Utils'
import { CiclePlus, CicleMinus, Rub } from '../../app-icon/Icons'
import Tooltip from '@material-ui/core/Tooltip'

// Import React Table
import ReactTable from 'react-table'
import 'react-table/react-table.css'
import './m-table-demo.css'

import withFixedColumns from 'react-table-hoc-fixed-columns'
import 'react-table-hoc-fixed-columns/lib/styles.css'

const ReactTableFixedColumns = withFixedColumns(ReactTable)

const styles = theme => ({
  tableWrapper: {
    maxWidth: '100%',
    margin: '0 10px 20px 10px',
    borderRadius: '8px',
    boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.1)',
    backgroundColor: '#fff',
    overflow: 'hidden',
    paddingBottom: 16,
  },
  tableTitle: {
    fontSize: '14px',
    textAlign: 'center',
    padding: '15px 0',
  },
  settingTitle: {
    display: 'flex',
    alignItems: 'center',
  },
  hint: { width: 280 },
  hintIcon: {
    position: 'absolute',
    top: 10,
    right: 10,
    // display: 'block',
    display: 'none',
    width: 24,
    height: 24,
    border: '1px solid rgb(136, 102, 255)',
    borderRadius: '50%',
    lineHeight: '23px',
    color: 'rgb(255, 255, 255)',
    fontWeight: 600,
    cursor: 'pointer',
    backgroundColor: 'rgb(136, 102, 255)',
    textAlign: 'center',
  },
  hintHelp: {
    textAlign: 'left !important',
    whiteSpace: 'normal !important',
    padding: '4px 8px',
  },
  tableSubtitle: {
    // marginRight: 25,
  },
})

class MTableAdvancedDemo extends Component {
  state = {
    data: this.props.data,
    summaryData: this.props.summaryData,
    defaultPageSize: this.props.data.length,
    resized: [],
    titles: this.props.titles,
    showColumn: false,
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.data !== this.props.data) {
      this.setState({
        data: this.props.data,
        defaultPageSize: this.props.data.length,
      })
    }

    if (prevProps.summaryData !== this.props.summaryData) {
      this.setState({
        summaryData: this.props.summaryData,
      })
    }

    if (prevProps.titles !== this.props.titles) {
      this.setState({
        titles: this.props.titles,
      })
    }
  }

  _handleResizeChange = resized => {
    this.setState({ resized })
  }

  _renderSubComponent = props => (
    <NestedTable
      {...props}
      titles={this.state.titles}
      resized={this.state.resized}
      parentState={this.state}
      parentProps={this.props}
    />
  )

  render() {
    const { classes, settings } = this.props
    const { data, summaryData, titles } = this.state

    const applicationFake = (
      <span className={classes.settingTitle}>Заявки {settings}</span>
    )
    const applicationFirst = titles.leadsGoalAlias ? (
      <span className={classes.settingTitle}>
        {titles.leadsGoalAlias} {!titles.leadsGoalId && settings}
      </span>
    ) : (
      <span className={classes.settingTitle}>
        Заявки {!titles.leadsGoalId && settings}
      </span>
    )
    const applicationSecond = titles.leads2GoalAlias ? (
      <span className={classes.settingTitle}>
        {titles.leads2GoalAlias} {!titles.leads2GoalId && settings}
      </span>
    ) : (
      <span className={classes.settingTitle}>
        Заявки {!titles.leads2GoalId && settings}
      </span>
    )
    const applicationThird = titles.leads3GoalAlias ? (
      <span className={classes.settingTitle}>
        {titles.leads3GoalAlias} {!titles.leads3GoalId && settings}
      </span>
    ) : (
      <span className={classes.settingTitle}>
        Заявки {!titles.leads3GoalId && settings}
      </span>
    )

    const callsFirst = titles.callsGoalAlias ? (
      <span className={classes.settingTitle}>
        {titles.callsGoalAlias} {!titles.callsGoalId && settings}
      </span>
    ) : (
      <span className={classes.settingTitle}>
        Звонки {!titles.callsGoalId && settings}
      </span>
    )
    const callsSecond = titles.calls2GoalAlias ? (
      <span className={classes.settingTitle}>
        {titles.calls2GoalAlias} {!titles.calls2GoalId && settings}
      </span>
    ) : (
      <span className={classes.settingTitle}>
        Звонки {!titles.calls2GoalId && settings}
      </span>
    )
    const callsThird = titles.calls3GoalAlias ? (
      <span className={classes.settingTitle}>
        {titles.calls3GoalAlias} {!titles.calls3GoalId && settings}
      </span>
    ) : (
      <span className={classes.settingTitle}>
        Звонки {!titles.calls3GoalId && settings}
      </span>
    )

    const orders = titles.ordersGoalAlias ? (
      <span className={classes.settingTitle}>
        {titles.ordersGoalAlias} {!titles.ordersGoalId && settings}
      </span>
    ) : (
      <span className={classes.settingTitle}>
        Продажи {!titles.ordersGoalId && settings}
      </span>
    )

    return (
      <div className={classes.tableWrapper}>
        <div className={classes.tableTitle}>Отчет по источникам трафика</div>

        <React.Fragment>
          <ReactTableFixedColumns
            data={data}
            pageSize={this.props.data.length}
            showPagination={false}
            resizable={true}
            onResizedChange={this._handleResizeChange}
            SubComponent={this._renderSubComponent}
            columns={[
              {
                Header: 'Источники',
                fixed: 'left',
                columns: [
                  {
                    Header: '',
                    expander: true,
                    width: 26,
                    filterable: false,
                    sortable: false,
                    resizable: false,
                    Expander: ({ isExpanded, ...rest }) => (
                      <div className="mainRow">
                        {isExpanded ? (
                          <div className="circle">
                            <CicleMinus
                              width={16}
                              height={16}
                              fill={'#8866ff'}
                            />
                          </div>
                        ) : (
                          <div className="circle">
                            <CiclePlus
                              width={16}
                              height={16}
                              fill={'#8866ff'}
                            />
                          </div>
                        )}
                      </div>
                    ),
                  },
                  {
                    Header: '',
                    id: 'source',
                    accessor: d => d.source,
                    width: 400,
                    resizable: false,
                    Cell: row => (
                      <div className="source-title">{`${row.original.source} / ${row.original.medium}`}</div>
                    ),
                    getProps: (state, rowInfo, column) => {
                      return {
                        style: {
                          justifyContent: 'flex-start',
                        },
                      }
                    },
                    Footer: () => <div>Общий итог</div>,
                  },
                ],
              },
              {
                Header: 'Трафик',
                columns: [
                  {
                    Header: `Показы`,
                    id: 'impressions',
                    accessor: d => Number(d.impressions),
                    minWidth: 70,
                    maxWidth: 85,
                    Cell: ({ value }) => {
                      return `${thousandSeparator(value)}`
                    },
                    filterable: false,
                    Footer: () => (
                      <div>{thousandSeparator(summaryData.impressions)}</div>
                    ),
                  },
                  {
                    Header: 'Сеансы',
                    id: 'sessions',
                    accessor: d => Number(d.sessions),
                    minWidth: 70,
                    maxWidth: 85,
                    Cell: ({ value }) => {
                      return `${thousandSeparator(value)}`
                    },
                    filterable: false,
                    Footer: () => (
                      <div>{thousandSeparator(summaryData.sessions)}</div>
                    ),
                  },
                  {
                    Header: (
                      <Fragment>
                        <span className={classes.tableSubtitle}>
                          Пользователи
                        </span>
                        <Tooltip
                          interactive
                          disableFocusListener
                          PopperProps={{
                            disablePortal: true,
                          }}
                          classes={{
                            tooltip: classes.hint,
                            popper: classes.popper,
                          }}
                          title={
                            <Fragment>
                              <div className={classes.hintHelp}>
                                Пользователи, для которых в указанный диапазон
                                дат зарегистрирован хотя бы один сеанс.
                              </div>
                            </Fragment>
                          }
                        >
                          <span className={classes.hintIcon}>?</span>
                        </Tooltip>
                      </Fragment>
                    ),
                    id: 'users',
                    accessor: d => Number(d.users),
                    width: 125,
                    Cell: ({ value }) => {
                      return `${thousandSeparator(value)}`
                    },
                    filterable: false,
                    Footer: () => (
                      <div>{thousandSeparator(summaryData.users)}</div>
                    ),
                  },
                  {
                    Header: 'Затраты\n на рекламу',
                    id: 'cost',
                    filterable: false,
                    width: 120,
                    accessor: d => Number(d.cost),
                    Cell: ({ value }) => {
                      return (
                        <span>
                          {`${thousandSeparator(value.toFixed(2))}`}
                          <Rub width={8} height={8} className="rub" />
                        </span>
                      )
                    },
                    Footer: () => (
                      <div>
                        {thousandSeparator(summaryData.cost.toFixed(2))}
                        <Rub width={8} height={8} className="rub" />
                      </div>
                    ),
                  },
                  {
                    Header: 'CPC',
                    id: 'cpc',
                    filterable: false,
                    minWidth: 70,
                    maxWidth: 85,
                    accessor: d => Number(d.cpc),
                    Cell: ({ value }) => {
                      return (
                        <span>
                          {`${thousandSeparator(value.toFixed(2))}`}
                          <Rub width={8} height={8} className="rub" />
                        </span>
                      )
                    },
                    Footer: () => (
                      <div>
                        {thousandSeparator(summaryData.cpc.toFixed(2))}
                        <Rub width={8} height={8} className="rub" />
                      </div>
                    ),
                  },
                ],
              },
              {
                Header: applicationFirst,
                columns: [
                  {
                    Header: 'Kонверсия',
                    id: 'leadsConversion',
                    filterable: false,
                    minWidth: 90,
                    show: !!titles.leadsGoalId,
                    accessor: d =>
                      d.leadsConversion !== null
                        ? Number(d.leadsConversion)
                        : '-',
                    Cell: ({ value }) => {
                      return value !== '-' ? (
                        <span>
                          {`${thousandSeparator(Number(value).toFixed(2))} %`}
                        </span>
                      ) : (
                        '-'
                      )
                    },
                    Footer: () => (
                      <div>
                        {summaryData.leadsConversion !== null ? (
                          <span>
                            {thousandSeparator(
                              summaryData.leadsConversion.toFixed(2)
                            )}{' '}
                            %
                          </span>
                        ) : (
                          '-'
                        )}
                      </div>
                    ),
                  },
                  {
                    Header: 'Кол-во',
                    id: 'leads',
                    minWidth: 75,
                    filterable: false,
                    show: !!titles.leadsGoalId,
                    accessor: d => (d.leads !== null ? Number(d.leads) : '-'),
                    Cell: ({ value }) => {
                      return value !== '-' ? (
                        <span>{`${thousandSeparator(value)}`}</span>
                      ) : (
                        '-'
                      )
                    },
                    Footer: () => (
                      <div>
                        {summaryData.leads !== null ? (
                          <span>{thousandSeparator(summaryData.leads)}</span>
                        ) : (
                          '-'
                        )}
                      </div>
                    ),
                  },
                  {
                    Header: 'Цена',
                    id: 'leadsPrice',
                    filterable: false,
                    minWidth: 90,
                    show: !!titles.leadsGoalId,
                    accessor: d =>
                      d.leadsPrice !== null ? Number(d.leadsPrice) : '-',
                    Cell: ({ value }) => {
                      return value !== '-' ? (
                        <span>
                          {`${thousandSeparator(value.toFixed(2))}`}
                          <Rub width={8} height={8} className="rub" />
                        </span>
                      ) : (
                        '-'
                      )
                    },
                    Footer: () => (
                      <div>
                        {summaryData.leadsPrice !== null ? (
                          <span>
                            {thousandSeparator(
                              summaryData.leadsPrice.toFixed(2)
                            )}
                            <Rub width={8} height={8} className="rub" />
                          </span>
                        ) : (
                          '-'
                        )}
                      </div>
                    ),
                  },
                ],
              },
              {
                Header: applicationSecond,
                columns: [
                  {
                    Header: 'Kонверсия',
                    id: 'leads2Conversion',
                    filterable: false,
                    minWidth: 90,
                    show: !!titles.leads2GoalId,
                    accessor: d =>
                      d.leads2Conversion !== null
                        ? Number(d.leads2Conversion)
                        : '-',
                    Cell: ({ value }) => {
                      return value !== '-' ? (
                        <span>
                          {`${thousandSeparator(Number(value).toFixed(2))} %`}
                        </span>
                      ) : (
                        '-'
                      )
                    },
                    Footer: () => (
                      <div>
                        {summaryData.leads2Conversion !== null ? (
                          <span>
                            {thousandSeparator(
                              summaryData.leads2Conversion.toFixed(2)
                            )}{' '}
                            %
                          </span>
                        ) : (
                          '-'
                        )}
                      </div>
                    ),
                  },
                  {
                    Header: 'Кол-во',
                    id: 'leads2',
                    minWidth: 75,
                    filterable: false,
                    show: !!titles.leads2GoalId,
                    accessor: d => (d.leads2 !== null ? Number(d.leads2) : '-'),
                    Cell: ({ value }) => {
                      return value !== '-' ? (
                        <span>{`${thousandSeparator(value)}`}</span>
                      ) : (
                        '-'
                      )
                    },
                    Footer: () => (
                      <div>
                        {summaryData.leads2 !== null ? (
                          <span>{thousandSeparator(summaryData.leads2)}</span>
                        ) : (
                          '-'
                        )}
                      </div>
                    ),
                  },
                  {
                    Header: 'Цена',
                    id: 'leads2Price',
                    filterable: false,
                    minWidth: 90,
                    show: !!titles.leads2GoalId,
                    accessor: d =>
                      d.leads2Price !== null ? Number(d.leads2Price) : '-',
                    Cell: ({ value }) => {
                      return value !== '-' ? (
                        <span>
                          {`${thousandSeparator(value.toFixed(2))}`}
                          <Rub width={8} height={8} className="rub" />
                        </span>
                      ) : (
                        '-'
                      )
                    },
                    Footer: () => (
                      <div>
                        {summaryData.leads2Price !== null ? (
                          <span>
                            {thousandSeparator(
                              summaryData.leads2Price.toFixed(2)
                            )}
                            <Rub width={8} height={8} className="rub" />
                          </span>
                        ) : (
                          '-'
                        )}
                      </div>
                    ),
                  },
                ],
              },
              {
                Header: applicationThird,
                columns: [
                  {
                    Header: 'Kонверсия',
                    id: 'leads3Conversion',
                    filterable: false,
                    minWidth: 90,
                    show: false,
                    show: !!titles.leads3GoalId,
                    accessor: d =>
                      d.leads3Conversion !== null
                        ? Number(d.leads3Conversion)
                        : '-',
                    Cell: ({ value }) => {
                      return value !== '-' ? (
                        <span>
                          {`${thousandSeparator(Number(value).toFixed(2))} %`}
                        </span>
                      ) : (
                        '-'
                      )
                    },
                    Footer: () => (
                      <div>
                        {summaryData.leads3Conversion !== null ? (
                          <span>
                            {thousandSeparator(
                              summaryData.leads3Conversion.toFixed(2)
                            )}{' '}
                            %
                          </span>
                        ) : (
                          '-'
                        )}
                      </div>
                    ),
                  },
                  {
                    Header: 'Кол-во',
                    id: 'leads3',
                    minWidth: 75,
                    filterable: false,
                    show: !!titles.leads3GoalId,
                    accessor: d => (d.leads3 !== null ? Number(d.leads3) : '-'),
                    Cell: ({ value }) => {
                      return value !== '-' ? (
                        <span>{`${thousandSeparator(value)}`}</span>
                      ) : (
                        '-'
                      )
                    },
                    Footer: () => (
                      <div>
                        {summaryData.leads3 !== null ? (
                          <span>{thousandSeparator(summaryData.leads3)}</span>
                        ) : (
                          '-'
                        )}
                      </div>
                    ),
                  },
                  {
                    Header: 'Цена',
                    id: 'leads3Price',
                    filterable: false,
                    minWidth: 90,
                    show: !!titles.leads3GoalId,
                    accessor: d =>
                      d.leads3Price !== null ? Number(d.leads3Price) : '-',
                    Cell: ({ value }) => {
                      return value !== '-' ? (
                        <span>
                          {`${thousandSeparator(value.toFixed(2))}`}
                          <Rub width={8} height={8} className="rub" />
                        </span>
                      ) : (
                        '-'
                      )
                    },
                    Footer: () => (
                      <div>
                        {summaryData.leads3Price !== null ? (
                          <span>
                            {thousandSeparator(
                              summaryData.leads3Price.toFixed(2)
                            )}
                            <Rub width={8} height={8} className="rub" />
                          </span>
                        ) : (
                          '-'
                        )}
                      </div>
                    ),
                  },
                ],
              },
              {
                Header: callsFirst,
                columns: [
                  {
                    Header: 'Kонверсия',
                    id: 'callsConversion',
                    filterable: false,
                    minWidth: 90,
                    show: !!titles.callsGoalId,
                    accessor: d =>
                      d.callsConversion !== null
                        ? Number(d.callsConversion)
                        : '-',
                    Cell: ({ value }) => {
                      return value !== '-' ? (
                        <span>
                          {`${thousandSeparator(Number(value).toFixed(2))} %`}
                        </span>
                      ) : (
                        '-'
                      )
                    },
                    Footer: () => (
                      <div>
                        {summaryData.callsConversion !== null ? (
                          <span>
                            {thousandSeparator(
                              summaryData.callsConversion.toFixed(2)
                            )}{' '}
                            %
                          </span>
                        ) : (
                          '-'
                        )}
                      </div>
                    ),
                  },
                  {
                    Header: 'Кол-во',
                    id: 'calls',
                    minWidth: 75,
                    filterable: false,
                    show: !!titles.callsGoalId,
                    accessor: d => (d.calls !== null ? Number(d.calls) : '-'),
                    Cell: ({ value }) => {
                      return value !== '-' ? (
                        <span>{`${thousandSeparator(value)}`}</span>
                      ) : (
                        '-'
                      )
                    },
                    Footer: () => (
                      <div>
                        {summaryData.calls !== null ? (
                          <span>{thousandSeparator(summaryData.calls)}</span>
                        ) : (
                          '-'
                        )}
                      </div>
                    ),
                  },
                  {
                    Header: 'Цена',
                    id: 'callsPrice',
                    filterable: false,
                    minWidth: 90,
                    show: !!titles.callsGoalId,
                    accessor: d =>
                      d.callsPrice !== null ? Number(d.callsPrice) : '-',
                    Cell: ({ value }) => {
                      return value !== '-' ? (
                        <span>
                          {`${thousandSeparator(value.toFixed(2))}`}
                          <Rub width={8} height={8} className="rub" />
                        </span>
                      ) : (
                        '-'
                      )
                    },
                    Footer: () => (
                      <div>
                        {summaryData.callsPrice !== null ? (
                          <span>
                            {thousandSeparator(
                              summaryData.callsPrice.toFixed(2)
                            )}
                            <Rub width={8} height={8} className="rub" />
                          </span>
                        ) : (
                          '-'
                        )}
                      </div>
                    ),
                  },
                ],
              },
              {
                Header: callsSecond,
                columns: [
                  {
                    Header: 'Kонверсия',
                    id: 'calls2Conversion',
                    filterable: false,
                    minWidth: 90,
                    show: !!titles.calls2GoalId,
                    accessor: d =>
                      d.calls2Conversion !== null
                        ? Number(d.calls2Conversion)
                        : '-',
                    Cell: ({ value }) => {
                      return value !== '-' ? (
                        <span>
                          {`${thousandSeparator(Number(value).toFixed(2))} %`}
                        </span>
                      ) : (
                        '-'
                      )
                    },
                    Footer: () => (
                      <div>
                        {summaryData.calls2Conversion !== null ? (
                          <span>
                            {thousandSeparator(
                              summaryData.calls2Conversion.toFixed(2)
                            )}{' '}
                            %
                          </span>
                        ) : (
                          '-'
                        )}
                      </div>
                    ),
                  },
                  {
                    Header: 'Кол-во',
                    id: 'calls2',
                    minWidth: 75,
                    filterable: false,
                    show: !!titles.calls2GoalId,
                    accessor: d => (d.calls2 !== null ? Number(d.calls2) : '-'),
                    Cell: ({ value }) => {
                      return value !== '-' ? (
                        <span>{`${thousandSeparator(value)}`}</span>
                      ) : (
                        '-'
                      )
                    },
                    Footer: () => (
                      <div>
                        {summaryData.calls2 !== null ? (
                          <span>{thousandSeparator(summaryData.calls2)}</span>
                        ) : (
                          '-'
                        )}
                      </div>
                    ),
                  },
                  {
                    Header: 'Цена',
                    id: 'calls2Price',
                    filterable: false,
                    minWidth: 90,
                    show: !!titles.calls2GoalId,
                    accessor: d =>
                      d.calls2Price !== null ? Number(d.calls2Price) : '-',
                    Cell: ({ value }) => {
                      return value !== '-' ? (
                        <span>
                          {`${thousandSeparator(value.toFixed(2))}`}
                          <Rub width={8} height={8} className="rub" />
                        </span>
                      ) : (
                        '-'
                      )
                    },
                    Footer: () => (
                      <div>
                        {summaryData.calls2Price !== null ? (
                          <span>
                            {thousandSeparator(
                              summaryData.calls2Price.toFixed(2)
                            )}
                            <Rub width={8} height={8} className="rub" />
                          </span>
                        ) : (
                          '-'
                        )}
                      </div>
                    ),
                  },
                ],
              },
              {
                Header: callsThird,
                columns: [
                  {
                    Header: 'Kонверсия',
                    id: 'calls3Conversion',
                    filterable: false,
                    minWidth: 90,
                    show: !!titles.calls3GoalId,
                    accessor: d =>
                      d.calls3Conversion !== null
                        ? Number(d.calls3Conversion)
                        : '-',
                    Cell: ({ value }) => {
                      return value !== '-' ? (
                        <span>
                          {`${thousandSeparator(Number(value).toFixed(2))} %`}
                        </span>
                      ) : (
                        '-'
                      )
                    },
                    Footer: () => (
                      <div>
                        {summaryData.calls3Conversion !== null ? (
                          <span>
                            {thousandSeparator(
                              summaryData.calls3Conversion.toFixed(2)
                            )}{' '}
                            %
                          </span>
                        ) : (
                          '-'
                        )}
                      </div>
                    ),
                  },
                  {
                    Header: 'Кол-во',
                    id: 'calls3',
                    minWidth: 75,
                    filterable: false,
                    show: !!titles.calls3GoalId,
                    accessor: d => (d.calls3 !== null ? Number(d.calls3) : '-'),
                    Cell: ({ value }) => {
                      return value !== '-' ? (
                        <span>{`${thousandSeparator(value)}`}</span>
                      ) : (
                        '-'
                      )
                    },
                    Footer: () => (
                      <div>
                        {summaryData.calls3 !== null ? (
                          <span>{thousandSeparator(summaryData.calls3)}</span>
                        ) : (
                          '-'
                        )}
                      </div>
                    ),
                  },
                  {
                    Header: 'Цена',
                    id: 'calls3Price',
                    filterable: false,
                    minWidth: 90,
                    show: !!titles.calls3GoalId,
                    accessor: d =>
                      d.calls3Price !== null ? Number(d.calls3Price) : '-',
                    Cell: ({ value }) => {
                      return value !== '-' ? (
                        <span>
                          {`${thousandSeparator(value.toFixed(2))}`}
                          <Rub width={8} height={8} className="rub" />
                        </span>
                      ) : (
                        '-'
                      )
                    },
                    Footer: () => (
                      <div>
                        {summaryData.calls3Price !== null ? (
                          <span>
                            {thousandSeparator(
                              summaryData.calls3Price.toFixed(2)
                            )}
                            <Rub width={8} height={8} className="rub" />
                          </span>
                        ) : (
                          '-'
                        )}
                      </div>
                    ),
                  },
                ],
              },
              {
                Header: orders,
                columns: [
                  {
                    Header: 'Kонверсия',
                    id: 'ordersConversion',
                    filterable: false,
                    minWidth: 90,
                    accessor: d =>
                      d.ordersConversion !== null
                        ? Number(d.ordersConversion)
                        : '-',
                    Cell: ({ value }) => {
                      return value !== '-' ? (
                        <span>
                          {`${thousandSeparator(Number(value).toFixed(2))} %`}
                        </span>
                      ) : (
                        '-'
                      )
                    },
                    Footer: () => (
                      <div>
                        {summaryData.ordersConversion !== null ? (
                          <span>
                            {thousandSeparator(
                              summaryData.ordersConversion.toFixed(2)
                            )}{' '}
                            %
                          </span>
                        ) : (
                          '-'
                        )}
                      </div>
                    ),
                  },
                  {
                    Header: 'Кол-во',
                    id: 'orders',
                    minWidth: 75,
                    filterable: false,
                    accessor: d => (d.orders !== null ? Number(d.orders) : '-'),
                    Cell: ({ value }) => {
                      return value !== '-' ? (
                        <span>{`${thousandSeparator(value)}`}</span>
                      ) : (
                        '-'
                      )
                    },
                    Footer: () => (
                      <div>
                        {summaryData.orders !== null ? (
                          <span>{thousandSeparator(summaryData.orders)}</span>
                        ) : (
                          '-'
                        )}
                      </div>
                    ),
                  },
                  {
                    Header: 'Выручка',
                    id: 'revenue',
                    filterable: false,
                    minWidth: 90,
                    accessor: d =>
                      d.revenue !== null ? Number(d.revenue) : '-',
                    Cell: ({ value }) => {
                      return value !== '-' ? (
                        <span>
                          {`${thousandSeparator(value.toFixed(2))}`}
                          <Rub width={8} height={8} className="rub" />
                        </span>
                      ) : (
                        '-'
                      )
                    },
                    Footer: () => (
                      <div>
                        {summaryData.revenue !== null ? (
                          <span>
                            {thousandSeparator(summaryData.revenue.toFixed(2))}
                            <Rub width={8} height={8} className="rub" />
                          </span>
                        ) : (
                          '-'
                        )}
                      </div>
                    ),
                  },
                  {
                    Header: 'CPO',
                    id: 'cpo',
                    filterable: false,
                    minWidth: 90,
                    accessor: d => (d.cpo !== null ? Number(d.cpo) : '-'),
                    Cell: ({ value }) => {
                      return value !== '-' ? (
                        <span>
                          {`${thousandSeparator(value.toFixed(2))}`}
                          <Rub width={8} height={8} className="rub" />
                        </span>
                      ) : (
                        '-'
                      )
                    },
                    Footer: () => (
                      <div>
                        {summaryData.cpo !== null ? (
                          <span>
                            {thousandSeparator(summaryData.cpo.toFixed(2))}{' '}
                            <Rub width={8} height={8} className="rub" />
                          </span>
                        ) : (
                          '-'
                        )}
                      </div>
                    ),
                  },
                  {
                    Header: 'ROMI',
                    id: 'romi',
                    filterable: false,
                    resizable: false,
                    minWidth: 75,
                    accessor: d => (d.romi !== null ? Number(d.romi) : '-'),
                    Cell: ({ value }) => {
                      return value !== '-' ? (
                        <span>
                          {`${thousandSeparator(Number(value).toFixed(2))} %`}
                        </span>
                      ) : (
                        '-'
                      )
                    },
                    Footer: () => (
                      <div>
                        {summaryData.romi !== null ? (
                          <span>
                            {thousandSeparator(summaryData.romi.toFixed(2))} %
                          </span>
                        ) : (
                          '-'
                        )}
                      </div>
                    ),
                  },
                ],
              },
            ]}
            defaultSorted={[
              {
                id: 'cost',
                desc: true,
              },
            ]}
            noDataText="Нет данных"
            style={{ height: 522 }}
            className="-striped -highlight"
          />
        </React.Fragment>
      </div>
    )
  }
}

class NestedTable extends Component {
  render() {
    const { campaigns } = this.props.original
    const { resized, titles } = this.props

    return (
      <ReactTableFixedColumns
        data={campaigns}
        pageSize={campaigns.length}
        showPagination={false}
        resized={resized}
        columns={[
          {
            Header: 'Источники',
            fixed: 'left',
            columns: [
              {
                width: 26,
                Header: '',
                resizable: false,
              },
              {
                Header: '',
                expander: true,
                width: 400,
                filterAll: false,
                resizable: false,
                className: 'firstLevel',
                Expander: ({ isExpanded, ...rest }) => {
                  if (
                    rest.original.terms == null ||
                    rest.original.terms.length == 0
                  ) {
                    return (
                      <div className="subRow">
                        <div
                          className="tablePoint"
                          style={{ cursorPointer: 'none' }}
                        ></div>
                        <div className="source-title">
                          {rest.original.campaign}
                        </div>
                      </div>
                    )
                  }
                  return (
                    <div className="subRow">
                      <div className="table-toggle">
                        {isExpanded ? (
                          <div className="circle">
                            <CicleMinus
                              width={16}
                              height={16}
                              fill={'#8866ff'}
                            />
                          </div>
                        ) : (
                          <div className="circle">
                            <CiclePlus
                              width={16}
                              height={16}
                              fill={'#8866ff'}
                            />
                          </div>
                        )}
                      </div>
                      <div className="source-title">
                        {rest.original.campaign}
                      </div>
                    </div>
                  )
                },
                getProps: (state, rowInfo, column) => {
                  if (rowInfo) {
                    if (
                      rowInfo.original.terms == null ||
                      rowInfo.original.terms.length == 0
                    ) {
                      return {
                        onClick: () => {},
                      }
                    }
                  }
                  return {
                    style: {
                      padding: 0,
                    },
                  }
                },
              },
            ],
          },
          {
            Header: 'Трафик',
            columns: [
              {
                Header: 'Показы',
                id: 'impressions',
                accessor: d => Number(d.impressions),
                minWidth: 70,
                maxWidth: 85,
                Cell: ({ value }) => {
                  return `${thousandSeparator(value)}`
                },
              },
              {
                Header: 'Сеансы',
                id: 'sessions',
                accessor: d => Number(d.sessions),
                minWidth: 70,
                maxWidth: 85,
                Cell: ({ value }) => {
                  return `${thousandSeparator(value)}`
                },
              },
              {
                Header: 'Пользователи',
                id: 'users',
                accessor: d => Number(d.users),
                width: 125,
                Cell: ({ value }) => {
                  return `${thousandSeparator(value)}`
                },
              },
              {
                Header: 'Затраты\n на рекламу',
                id: 'cost',
                filterable: false,
                width: 120,
                accessor: d => Number(d.cost),
                Cell: ({ value }) => {
                  return (
                    <span>
                      {`${thousandSeparator(value.toFixed(2))}`}
                      <Rub width={8} height={8} className="rub" />
                    </span>
                  )
                },
              },
              {
                Header: 'CPC',
                id: 'cpc',
                filterable: false,
                minWidth: 70,
                maxWidth: 85,
                accessor: d => Number(d.cpc),
                Cell: ({ value }) => {
                  return (
                    <span>
                      {`${thousandSeparator(value.toFixed(2))}`}
                      <Rub width={8} height={8} className="rub" />
                    </span>
                  )
                },
              },
            ],
          },
          {
            Header: 'Заявки',
            columns: [
              {
                Header: 'Kонверсия\n в цель',
                id: 'leadsConversion',
                filterable: false,
                minWidth: 90,
                show: !!titles.leadsGoalId,
                accessor: d =>
                  d.leadsConversion !== null ? Number(d.leadsConversion) : '-',
                Cell: ({ value }) => {
                  return value !== '-' ? (
                    <span>
                      {`${thousandSeparator(Number(value).toFixed(2))} %`}
                    </span>
                  ) : (
                    '-'
                  )
                },
              },
              {
                Header: 'Цель\n (кол-во)',
                id: 'leads',
                minWidth: 75,
                filterable: false,
                show: !!titles.leadsGoalId,
                accessor: d => (d.leads !== null ? Number(d.leads) : '-'),
                Cell: ({ value }) => {
                  return value !== '-' ? (
                    <span>{`${thousandSeparator(value)}`}</span>
                  ) : (
                    '-'
                  )
                },
              },
              {
                Header: 'Цена',
                id: 'leadsPrice',
                filterable: false,
                minWidth: 90,
                show: !!titles.leadsGoalId,
                accessor: d =>
                  d.leadsPrice !== null ? Number(d.leadsPrice) : '-',
                Cell: ({ value }) => {
                  return value !== '-' ? (
                    <span>
                      {`${thousandSeparator(value.toFixed(2))}`}
                      <Rub width={8} height={8} className="rub" />
                    </span>
                  ) : (
                    '-'
                  )
                },
              },
            ],
          },
          {
            Header: 'Заявки',
            columns: [
              {
                Header: 'Kонверсия\n в цель',
                id: 'leads2Conversion',
                filterable: false,
                minWidth: 90,
                show: !!titles.leads2GoalId,
                accessor: d =>
                  d.leads2Conversion !== null
                    ? Number(d.leads2Conversion)
                    : '-',
                Cell: ({ value }) => {
                  return value !== '-' ? (
                    <span>
                      {`${thousandSeparator(Number(value).toFixed(2))} %`}
                    </span>
                  ) : (
                    '-'
                  )
                },
              },
              {
                Header: 'Цель\n (кол-во)',
                id: 'leads2',
                minWidth: 75,
                filterable: false,
                show: !!titles.leads2GoalId,
                accessor: d => (d.leads2 !== null ? Number(d.leads2) : '-'),
                Cell: ({ value }) => {
                  return value !== '-' ? (
                    <span>{`${thousandSeparator(value)}`}</span>
                  ) : (
                    '-'
                  )
                },
              },
              {
                Header: 'Цена',
                id: 'leads2Price',
                filterable: false,
                minWidth: 90,
                show: !!titles.leads2GoalId,
                accessor: d =>
                  d.leads2Price !== null ? Number(d.leads2Price) : '-',
                Cell: ({ value }) => {
                  return value !== '-' ? (
                    <span>
                      {`${thousandSeparator(value.toFixed(2))}`}
                      <Rub width={8} height={8} className="rub" />
                    </span>
                  ) : (
                    '-'
                  )
                },
              },
            ],
          },
          {
            Header: 'Заявки',
            columns: [
              {
                Header: 'Kонверсия\n в цель',
                id: 'leads3Conversion',
                filterable: false,
                minWidth: 90,
                show: !!titles.leads3GoalId,
                accessor: d =>
                  d.leads3Conversion !== null
                    ? Number(d.leads3Conversion)
                    : '-',
                Cell: ({ value }) => {
                  return value !== '-' ? (
                    <span>
                      {`${thousandSeparator(Number(value).toFixed(2))} %`}
                    </span>
                  ) : (
                    '-'
                  )
                },
              },
              {
                Header: 'Цель\n (кол-во)',
                id: 'leads3',
                minWidth: 75,
                filterable: false,
                show: !!titles.leads3GoalId,
                accessor: d => (d.leads3 !== null ? Number(d.leads3) : '-'),
                Cell: ({ value }) => {
                  return value !== '-' ? (
                    <span>{`${thousandSeparator(value)}`}</span>
                  ) : (
                    '-'
                  )
                },
              },
              {
                Header: 'Цена',
                id: 'leads3Price',
                filterable: false,
                minWidth: 90,
                show: !!titles.leads3GoalId,
                accessor: d =>
                  d.leads3Price !== null ? Number(d.leads3Price) : '-',
                Cell: ({ value }) => {
                  return value !== '-' ? (
                    <span>
                      {`${thousandSeparator(value.toFixed(2))}`}
                      <Rub width={8} height={8} className="rub" />
                    </span>
                  ) : (
                    '-'
                  )
                },
              },
            ],
          },
          {
            Header: 'Звонки',
            columns: [
              {
                Header: 'Kонверсия\n в цель',
                id: 'callsConversion',
                filterable: false,
                minWidth: 90,
                show: !!titles.callsGoalId,
                accessor: d =>
                  d.callsConversion !== null ? Number(d.callsConversion) : '-',
                Cell: ({ value }) => {
                  return value !== '-' ? (
                    <span>
                      {`${thousandSeparator(Number(value).toFixed(2))} %`}
                    </span>
                  ) : (
                    '-'
                  )
                },
              },
              {
                Header: 'Цель\n (кол-во)',
                id: 'calls',
                minWidth: 75,
                filterable: false,
                show: !!titles.callsGoalId,
                accessor: d => (d.calls !== null ? Number(d.calls) : '-'),
                Cell: ({ value }) => {
                  return value !== '-' ? (
                    <span>{`${thousandSeparator(value)}`}</span>
                  ) : (
                    '-'
                  )
                },
              },
              {
                Header: 'Цена',
                id: 'callsPrice',
                filterable: false,
                minWidth: 90,
                show: !!titles.callsGoalId,
                accessor: d =>
                  d.callsPrice !== null ? Number(d.callsPrice) : '-',
                Cell: ({ value }) => {
                  return value !== '-' ? (
                    <span>
                      {`${thousandSeparator(value.toFixed(2))}`}
                      <Rub width={8} height={8} className="rub" />
                    </span>
                  ) : (
                    '-'
                  )
                },
              },
            ],
          },
          {
            Header: 'Звонки',
            columns: [
              {
                Header: 'Kонверсия\n в цель',
                id: 'calls2Conversion',
                filterable: false,
                minWidth: 90,
                show: !!titles.calls2GoalId,
                accessor: d =>
                  d.calls2Conversion !== null
                    ? Number(d.calls2Conversion)
                    : '-',
                Cell: ({ value }) => {
                  return value !== '-' ? (
                    <span>
                      {`${thousandSeparator(Number(value).toFixed(2))} %`}
                    </span>
                  ) : (
                    '-'
                  )
                },
              },
              {
                Header: 'Цель\n (кол-во)',
                id: 'calls2',
                minWidth: 75,
                filterable: false,
                show: !!titles.calls2GoalId,
                accessor: d => (d.calls2 !== null ? Number(d.calls2) : '-'),
                Cell: ({ value }) => {
                  return value !== '-' ? (
                    <span>{`${thousandSeparator(value)}`}</span>
                  ) : (
                    '-'
                  )
                },
              },
              {
                Header: 'Цена',
                id: 'calls2Price',
                filterable: false,
                minWidth: 90,
                show: !!titles.calls2GoalId,
                accessor: d =>
                  d.calls2Price !== null ? Number(d.calls2Price) : '-',
                Cell: ({ value }) => {
                  return value !== '-' ? (
                    <span>
                      {`${thousandSeparator(value.toFixed(2))}`}
                      <Rub width={8} height={8} className="rub" />
                    </span>
                  ) : (
                    '-'
                  )
                },
              },
            ],
          },
          {
            Header: 'Звонки',
            columns: [
              {
                Header: 'Kонверсия\n в цель',
                id: 'calls3Conversion',
                filterable: false,
                minWidth: 90,
                show: !!titles.calls3GoalId,
                accessor: d =>
                  d.calls3Conversion !== null
                    ? Number(d.calls3Conversion)
                    : '-',
                Cell: ({ value }) => {
                  return value !== '-' ? (
                    <span>
                      {`${thousandSeparator(Number(value).toFixed(2))} %`}
                    </span>
                  ) : (
                    '-'
                  )
                },
              },
              {
                Header: 'Цель\n (кол-во)',
                id: 'calls3',
                minWidth: 75,
                filterable: false,
                show: !!titles.calls3GoalId,
                accessor: d => (d.calls3 !== null ? Number(d.calls3) : '-'),
                Cell: ({ value }) => {
                  return value !== '-' ? (
                    <span>{`${thousandSeparator(value)}`}</span>
                  ) : (
                    '-'
                  )
                },
              },
              {
                Header: 'Цена',
                id: 'calls3Price',
                filterable: false,
                minWidth: 90,
                show: !!titles.calls3GoalId,
                accessor: d =>
                  d.calls3Price !== null ? Number(d.calls3Price) : '-',
                Cell: ({ value }) => {
                  return value !== '-' ? (
                    <span>
                      {`${thousandSeparator(value.toFixed(2))}`}
                      <Rub width={8} height={8} className="rub" />
                    </span>
                  ) : (
                    '-'
                  )
                },
              },
            ],
          },
          {
            Header: 'Продажи',
            columns: [
              {
                Header: 'Kонверсия\n в продажу',
                id: 'ordersConversion',
                filterable: false,
                minWidth: 90,
                accessor: d =>
                  d.ordersConversion !== null
                    ? Number(d.ordersConversion)
                    : '-',
                Cell: ({ value }) => {
                  return value !== '-' ? (
                    <span>
                      {`${thousandSeparator(Number(value).toFixed(2))} %`}
                    </span>
                  ) : (
                    '-'
                  )
                },
              },
              {
                Header: 'Кол-во',
                id: 'orders',
                minWidth: 75,
                filterable: false,
                accessor: d => (d.orders !== null ? Number(d.orders) : '-'),
                Cell: ({ value }) => {
                  return value !== '-' ? (
                    <span>{`${thousandSeparator(value)}`}</span>
                  ) : (
                    '-'
                  )
                },
              },
              {
                Header: 'Выручка',
                id: 'revenue',
                filterable: false,
                minWidth: 90,
                accessor: d => (d.revenue !== null ? Number(d.revenue) : '-'),
                Cell: ({ value }) => {
                  return value !== '-' ? (
                    <span>
                      {`${thousandSeparator(value.toFixed(2))}`}
                      <Rub width={8} height={8} className="rub" />
                    </span>
                  ) : (
                    '-'
                  )
                },
              },
              {
                Header: 'CPO',
                id: 'cpo',
                filterable: false,
                minWidth: 90,
                accessor: d => (d.cpo !== null ? Number(d.cpo) : '-'),
                Cell: ({ value }) => {
                  return value !== '-' ? (
                    <span>
                      {`${thousandSeparator(value.toFixed(2))}`}
                      <Rub width={8} height={8} className="rub" />
                    </span>
                  ) : (
                    '-'
                  )
                },
              },
              {
                Header: 'ROMI',
                id: 'romi',
                filterable: false,
                resizable: false,
                minWidth: 75,
                accessor: d => (d.romi !== null ? Number(d.romi) : '-'),
                Cell: ({ value }) => {
                  return value !== '-' ? (
                    <span>
                      {`${thousandSeparator(Number(value).toFixed(2))} %`}
                    </span>
                  ) : (
                    '-'
                  )
                },
              },
            ],
          },
        ]}
        SubComponent={row => {
          const { terms } = row.original
          return (
            <ReactTableFixedColumns
              data={terms}
              pageSize={terms.length}
              showPagination={false}
              resized={resized}
              columns={[
                {
                  Header: 'Источники',
                  fixed: 'left',
                  columns: [
                    {
                      width: 26,
                      Header: '',
                      resizable: false,
                    },
                    {
                      Header: '',
                      expander: true,
                      width: 400,
                      filterAll: false,
                      resizable: false,
                      className: 'secondLevel',
                      Expander: ({ isExpanded, ...rest }) => {
                        if (
                          rest.original.content == null ||
                          rest.original.content.length == 0
                        ) {
                          return (
                            <div className="subRow">
                              <div
                                className="tablePoint"
                                style={{ cursorPointer: 'none' }}
                              ></div>
                              <div className="source-title">
                                {rest.original.term}
                              </div>
                            </div>
                          )
                        }
                        return (
                          <div className="subRow">
                            <div className="table-toggle">
                              {isExpanded ? (
                                <div className="circle">
                                  <CicleMinus
                                    width={16}
                                    height={16}
                                    fill={'#8866ff'}
                                  />
                                </div>
                              ) : (
                                <div className="circle">
                                  <CiclePlus
                                    width={16}
                                    height={16}
                                    fill={'#8866ff'}
                                  />
                                </div>
                              )}
                            </div>
                            <div className="source-title">
                              {rest.original.term}
                            </div>
                          </div>
                        )
                      },
                      getProps: (state, rowInfo, column) => {
                        if (rowInfo) {
                          if (
                            rowInfo.original.content == null ||
                            rowInfo.original.content.length == 0
                          ) {
                            return {
                              onClick: () => {},
                            }
                          }
                        }
                        return {
                          style: {
                            padding: 0,
                          },
                        }
                      },
                    },
                  ],
                },
                {
                  Header: 'Трафик',
                  columns: [
                    {
                      Header: 'Показы',
                      id: 'impressions',
                      accessor: d => Number(d.impressions),
                      minWidth: 70,
                      maxWidth: 85,
                      Cell: ({ value }) => {
                        return `${thousandSeparator(value)}`
                      },
                    },
                    {
                      Header: 'Сеансы',
                      id: 'sessions',
                      accessor: d => Number(d.sessions),
                      minWidth: 70,
                      maxWidth: 85,
                      Cell: ({ value }) => {
                        return `${thousandSeparator(value)}`
                      },
                    },
                    {
                      Header: 'Пользователи',
                      id: 'users',
                      accessor: d => Number(d.users),
                      width: 125,
                      Cell: ({ value }) => {
                        return `${thousandSeparator(value)}`
                      },
                    },
                    {
                      Header: 'Затраты\n на рекламу',
                      id: 'cost',
                      filterable: false,
                      width: 120,
                      accessor: d => Number(d.cost),
                      Cell: ({ value }) => {
                        return (
                          <span>
                            {`${thousandSeparator(value.toFixed(2))}`}
                            <Rub width={8} height={8} className="rub" />
                          </span>
                        )
                      },
                    },
                    {
                      Header: 'CPC',
                      id: 'cpc',
                      filterable: false,
                      minWidth: 70,
                      maxWidth: 85,
                      accessor: d => Number(d.cpc),
                      Cell: ({ value }) => {
                        return (
                          <span>
                            {`${thousandSeparator(value.toFixed(2))}`}
                            <Rub width={8} height={8} className="rub" />
                          </span>
                        )
                      },
                    },
                  ],
                },
                {
                  Header: 'Заявки',
                  columns: [
                    {
                      Header: 'Kонверсия',
                      id: 'leadsConversion',
                      filterable: false,
                      minWidth: 90,
                      show: !!titles.leadsGoalId,
                      accessor: d =>
                        d.leadsConversion !== null
                          ? Number(d.leadsConversion)
                          : '-',
                      Cell: ({ value }) => {
                        return value !== '-' ? (
                          <span>
                            {`${thousandSeparator(Number(value).toFixed(2))} %`}
                          </span>
                        ) : (
                          '-'
                        )
                      },
                    },
                    {
                      Header: 'Цель\n (кол-во)',
                      id: 'leads',
                      minWidth: 75,
                      filterable: false,
                      show: !!titles.leadsGoalId,
                      accessor: d => (d.leads !== null ? Number(d.leads) : '-'),
                      Cell: ({ value }) => {
                        return value !== '-' ? (
                          <span>{`${thousandSeparator(value)}`}</span>
                        ) : (
                          '-'
                        )
                      },
                    },
                    {
                      Header: 'Цена',
                      id: 'leadsPrice',
                      filterable: false,
                      minWidth: 90,
                      show: !!titles.leadsGoalId,
                      accessor: d =>
                        d.leadsPrice !== null ? Number(d.leadsPrice) : '-',
                      Cell: ({ value }) => {
                        return value !== '-' ? (
                          <span>
                            {`${thousandSeparator(value.toFixed(2))}`}
                            <Rub width={8} height={8} className="rub" />
                          </span>
                        ) : (
                          '-'
                        )
                      },
                    },
                  ],
                },
                {
                  Header: 'Заявки',
                  columns: [
                    {
                      Header: 'Kонверсия\n в цель',
                      id: 'leads2Conversion',
                      filterable: false,
                      minWidth: 90,
                      show: !!titles.leads2GoalId,
                      accessor: d =>
                        d.leads2Conversion !== null
                          ? Number(d.leads2Conversion)
                          : '-',
                      Cell: ({ value }) => {
                        return value !== '-' ? (
                          <span>
                            {`${thousandSeparator(Number(value).toFixed(2))} %`}
                          </span>
                        ) : (
                          '-'
                        )
                      },
                    },
                    {
                      Header: 'Цель\n (кол-во)',
                      id: 'leads2',
                      minWidth: 75,
                      filterable: false,
                      show: !!titles.leads2GoalId,
                      accessor: d =>
                        d.leads2 !== null ? Number(d.leads2) : '-',
                      Cell: ({ value }) => {
                        return value !== '-' ? (
                          <span>{`${thousandSeparator(value)}`}</span>
                        ) : (
                          '-'
                        )
                      },
                    },
                    {
                      Header: 'Цена',
                      id: 'leads2Price',
                      filterable: false,
                      minWidth: 90,
                      show: !!titles.leads2GoalId,
                      accessor: d =>
                        d.leads2Price !== null ? Number(d.leads2Price) : '-',
                      Cell: ({ value }) => {
                        return value !== '-' ? (
                          <span>
                            {`${thousandSeparator(value.toFixed(2))}`}
                            <Rub width={8} height={8} className="rub" />
                          </span>
                        ) : (
                          '-'
                        )
                      },
                    },
                  ],
                },
                {
                  Header: 'Заявки',
                  columns: [
                    {
                      Header: 'Kонверсия\n в цель',
                      id: 'leads3Conversion',
                      filterable: false,
                      minWidth: 90,
                      show: !!titles.leads3GoalId,
                      accessor: d =>
                        d.leads3Conversion !== null
                          ? Number(d.leads3Conversion)
                          : '-',
                      Cell: ({ value }) => {
                        return value !== '-' ? (
                          <span>
                            {`${thousandSeparator(Number(value).toFixed(2))} %`}
                          </span>
                        ) : (
                          '-'
                        )
                      },
                    },
                    {
                      Header: 'Цель\n (кол-во)',
                      id: 'leads3',
                      minWidth: 75,
                      filterable: false,
                      show: !!titles.leads3GoalId,
                      accessor: d =>
                        d.leads3 !== null ? Number(d.leads3) : '-',
                      Cell: ({ value }) => {
                        return value !== '-' ? (
                          <span>{`${thousandSeparator(value)}`}</span>
                        ) : (
                          '-'
                        )
                      },
                    },
                    {
                      Header: 'Цена',
                      id: 'leads3Price',
                      filterable: false,
                      minWidth: 90,
                      show: !!titles.leads3GoalId,
                      accessor: d =>
                        d.leads3Price !== null ? Number(d.leads3Price) : '-',
                      Cell: ({ value }) => {
                        return value !== '-' ? (
                          <span>
                            {`${thousandSeparator(value.toFixed(2))}`}
                            <Rub width={8} height={8} className="rub" />
                          </span>
                        ) : (
                          '-'
                        )
                      },
                    },
                  ],
                },
                {
                  Header: 'Звонки',
                  columns: [
                    {
                      Header: 'Kонверсия\n в цель',
                      id: 'callsConversion',
                      filterable: false,
                      minWidth: 90,
                      show: !!titles.callsGoalId,
                      accessor: d =>
                        d.callsConversion !== null
                          ? Number(d.callsConversion)
                          : '-',
                      Cell: ({ value }) => {
                        return value !== '-' ? (
                          <span>
                            {`${thousandSeparator(Number(value).toFixed(2))} %`}
                          </span>
                        ) : (
                          '-'
                        )
                      },
                    },
                    {
                      Header: 'Цель\n (кол-во)',
                      id: 'calls',
                      minWidth: 75,
                      filterable: false,
                      show: !!titles.callsGoalId,
                      accessor: d => (d.calls !== null ? Number(d.calls) : '-'),
                      Cell: ({ value }) => {
                        return value !== '-' ? (
                          <span>{`${thousandSeparator(value)}`}</span>
                        ) : (
                          '-'
                        )
                      },
                    },
                    {
                      Header: 'Цена',
                      id: 'callsPrice',
                      filterable: false,
                      minWidth: 90,
                      show: !!titles.callsGoalId,
                      accessor: d =>
                        d.callsPrice !== null ? Number(d.callsPrice) : '-',
                      Cell: ({ value }) => {
                        return value !== '-' ? (
                          <span>
                            {`${thousandSeparator(value.toFixed(2))}`}
                            <Rub width={8} height={8} className="rub" />
                          </span>
                        ) : (
                          '-'
                        )
                      },
                    },
                  ],
                },
                {
                  Header: 'Звонки',
                  columns: [
                    {
                      Header: 'Kонверсия\n в цель',
                      id: 'calls2Conversion',
                      filterable: false,
                      minWidth: 90,
                      show: !!titles.calls2GoalId,
                      accessor: d =>
                        d.calls2Conversion !== null
                          ? Number(d.calls2Conversion)
                          : '-',
                      Cell: ({ value }) => {
                        return value !== '-' ? (
                          <span>
                            {`${thousandSeparator(Number(value).toFixed(2))} %`}
                          </span>
                        ) : (
                          '-'
                        )
                      },
                    },
                    {
                      Header: 'Цель\n (кол-во)',
                      id: 'calls2',
                      minWidth: 75,
                      filterable: false,
                      show: !!titles.calls2GoalId,
                      accessor: d =>
                        d.calls2 !== null ? Number(d.calls2) : '-',
                      Cell: ({ value }) => {
                        return value !== '-' ? (
                          <span>{`${thousandSeparator(value)}`}</span>
                        ) : (
                          '-'
                        )
                      },
                    },
                    {
                      Header: 'Цена',
                      id: 'calls2Price',
                      filterable: false,
                      minWidth: 90,
                      show: !!titles.calls2GoalId,
                      accessor: d =>
                        d.calls2Price !== null ? Number(d.calls2Price) : '-',
                      Cell: ({ value }) => {
                        return value !== '-' ? (
                          <span>
                            {`${thousandSeparator(value.toFixed(2))}`}
                            <Rub width={8} height={8} className="rub" />
                          </span>
                        ) : (
                          '-'
                        )
                      },
                    },
                  ],
                },
                {
                  Header: 'Звонки',
                  columns: [
                    {
                      Header: 'Kонверсия\n в цель',
                      id: 'calls3Conversion',
                      filterable: false,
                      minWidth: 90,
                      show: !!titles.calls3GoalId,
                      accessor: d =>
                        d.calls3Conversion !== null
                          ? Number(d.calls3Conversion)
                          : '-',
                      Cell: ({ value }) => {
                        return value !== '-' ? (
                          <span>
                            {`${thousandSeparator(Number(value).toFixed(2))} %`}
                          </span>
                        ) : (
                          '-'
                        )
                      },
                    },
                    {
                      Header: 'Цель\n (кол-во)',
                      id: 'calls3',
                      minWidth: 75,
                      filterable: false,
                      show: !!titles.calls3GoalId,
                      accessor: d =>
                        d.calls3 !== null ? Number(d.calls3) : '-',
                      Cell: ({ value }) => {
                        return value !== '-' ? (
                          <span>{`${thousandSeparator(value)}`}</span>
                        ) : (
                          '-'
                        )
                      },
                    },
                    {
                      Header: 'Цена',
                      id: 'calls3Price',
                      filterable: false,
                      minWidth: 90,
                      show: !!titles.calls3GoalId,
                      accessor: d =>
                        d.calls3Price !== null ? Number(d.calls3Price) : '-',
                      Cell: ({ value }) => {
                        return value !== '-' ? (
                          <span>
                            {`${thousandSeparator(value.toFixed(2))}`}
                            <Rub width={8} height={8} className="rub" />
                          </span>
                        ) : (
                          '-'
                        )
                      },
                    },
                  ],
                },
                {
                  Header: 'Продажи',
                  columns: [
                    {
                      Header: 'Kонверсия\n в продажу',
                      id: 'ordersConversion',
                      filterable: false,
                      minWidth: 90,
                      accessor: d =>
                        d.ordersConversion !== null
                          ? Number(d.ordersConversion)
                          : '-',
                      Cell: ({ value }) => {
                        return value !== '-' ? (
                          <span>
                            {`${thousandSeparator(Number(value).toFixed(2))} %`}
                          </span>
                        ) : (
                          '-'
                        )
                      },
                    },
                    {
                      Header: 'Кол-во',
                      id: 'orders',
                      minWidth: 75,
                      filterable: false,
                      accessor: d =>
                        d.orders !== null ? Number(d.orders) : '-',
                      Cell: ({ value }) => {
                        return value !== '-' ? (
                          <span>{`${thousandSeparator(value)}`}</span>
                        ) : (
                          '-'
                        )
                      },
                    },
                    {
                      Header: 'Выручка',
                      id: 'revenue',
                      filterable: false,
                      minWidth: 90,
                      accessor: d =>
                        d.revenue !== null ? Number(d.revenue) : '-',
                      Cell: ({ value }) => {
                        return value !== '-' ? (
                          <span>
                            {`${thousandSeparator(value.toFixed(2))}`}
                            <Rub width={8} height={8} className="rub" />
                          </span>
                        ) : (
                          '-'
                        )
                      },
                    },
                    {
                      Header: 'CPO',
                      id: 'cpo',
                      filterable: false,
                      minWidth: 90,
                      accessor: d => (d.cpo !== null ? Number(d.cpo) : '-'),
                      Cell: ({ value }) => {
                        return value !== '-' ? (
                          <span>
                            {`${thousandSeparator(value.toFixed(2))}`}
                            <Rub width={8} height={8} className="rub" />
                          </span>
                        ) : (
                          '-'
                        )
                      },
                    },
                    {
                      Header: 'ROMI',
                      id: 'romi',
                      filterable: false,
                      resizable: false,
                      minWidth: 75,
                      accessor: d => (d.romi !== null ? Number(d.romi) : '-'),
                      Cell: ({ value }) => {
                        return value !== '-' ? (
                          <span>
                            {`${thousandSeparator(Number(value).toFixed(2))} %`}
                          </span>
                        ) : (
                          '-'
                        )
                      },
                    },
                  ],
                },
              ]}
              SubComponent={row => {
                const { content } = row.original
                return (
                  <ReactTableFixedColumns
                    data={content}
                    pageSize={content.length}
                    showPagination={false}
                    resized={resized}
                    columns={[
                      {
                        Header: 'Источники',
                        fixed: 'left',
                        columns: [
                          {
                            Header: '',
                            width: 26,
                            resizable: false,
                          },
                          {
                            Header: '',
                            id: 'source',
                            resizable: false,
                            accessor: d => d.source,
                            width: 400,
                            filterAll: false,
                            Cell: row => {
                              return (
                                <div className="subRow">
                                  <div className="tablePoint"></div>
                                  <div className="content-title">
                                    {`${row.original.content}`}
                                  </div>
                                </div>
                              )
                            },
                            getProps: (state, rowInfo, column) => {
                              return {
                                className: 'thirdLevel',
                              }
                            },
                          },
                        ],
                      },
                      {
                        Header: 'Трафик',
                        columns: [
                          {
                            Header: 'Показы',
                            id: 'impressions',
                            accessor: d => Number(d.impressions),
                            minWidth: 70,
                            maxWidth: 85,
                            Cell: ({ value }) => {
                              return `${thousandSeparator(value)}`
                            },
                          },
                          {
                            Header: 'Сеансы',
                            id: 'sessions',
                            accessor: d => Number(d.sessions),
                            minWidth: 70,
                            maxWidth: 85,
                            Cell: ({ value }) => {
                              return `${thousandSeparator(value)}`
                            },
                          },
                          {
                            Header: 'Пользователи',
                            id: 'users',
                            accessor: d => Number(d.users),
                            width: 125,
                            Cell: ({ value }) => {
                              return `${thousandSeparator(value)}`
                            },
                          },
                          {
                            Header: 'Затраты\n на рекламу',
                            id: 'cost',
                            filterable: false,
                            width: 120,
                            accessor: d => Number(d.cost),
                            Cell: ({ value }) => {
                              return (
                                <span>
                                  {`${thousandSeparator(value.toFixed(2))}`}
                                  <Rub width={8} height={8} className="rub" />
                                </span>
                              )
                            },
                          },
                          {
                            Header: 'CPC',
                            id: 'cpc',
                            filterable: false,
                            minWidth: 70,
                            maxWidth: 85,
                            accessor: d => Number(d.cpc),
                            Cell: ({ value }) => {
                              return (
                                <span>
                                  {`${thousandSeparator(value.toFixed(2))}`}
                                  <Rub width={8} height={8} className="rub" />
                                </span>
                              )
                            },
                          },
                        ],
                      },
                      {
                        Header: 'Заявки',
                        columns: [
                          {
                            Header: 'Kонверсия\n в цель',
                            id: 'leadsConversion',
                            filterable: false,
                            minWidth: 90,
                            show: !!titles.leadsGoalId,
                            accessor: d =>
                              d.leadsConversion !== null
                                ? Number(d.leadsConversion)
                                : '-',
                            Cell: ({ value }) => {
                              return value !== '-' ? (
                                <span>
                                  {`${thousandSeparator(
                                    Number(value).toFixed(2)
                                  )} %`}
                                </span>
                              ) : (
                                '-'
                              )
                            },
                          },
                          {
                            Header: 'Цель\n (кол-во)',
                            id: 'leads',
                            minWidth: 75,
                            filterable: false,
                            show: !!titles.leadsGoalId,
                            accessor: d =>
                              d.leads !== null ? Number(d.leads) : '-',
                            Cell: ({ value }) => {
                              return value !== '-' ? (
                                <span>{`${thousandSeparator(value)}`}</span>
                              ) : (
                                '-'
                              )
                            },
                          },
                          {
                            Header: 'Цена',
                            id: 'leadsPrice',
                            filterable: false,
                            minWidth: 90,
                            show: !!titles.leadsGoalId,
                            accessor: d =>
                              d.leadsPrice !== null
                                ? Number(d.leadsPrice)
                                : '-',
                            Cell: ({ value }) => {
                              return value !== '-' ? (
                                <span>
                                  {`${thousandSeparator(value.toFixed(2))}`}
                                  <Rub width={8} height={8} className="rub" />
                                </span>
                              ) : (
                                '-'
                              )
                            },
                          },
                        ],
                      },
                      {
                        Header: 'Заявки',
                        columns: [
                          {
                            Header: 'Kонверсия\n в цель',
                            id: 'leads2Conversion',
                            filterable: false,
                            minWidth: 90,
                            show: !!titles.leads2GoalId,
                            accessor: d =>
                              d.leads2Conversion !== null
                                ? Number(d.leads2Conversion)
                                : '-',
                            Cell: ({ value }) => {
                              return value !== '-' ? (
                                <span>
                                  {`${thousandSeparator(
                                    Number(value).toFixed(2)
                                  )} %`}
                                </span>
                              ) : (
                                '-'
                              )
                            },
                          },
                          {
                            Header: 'Цель\n (кол-во)',
                            id: 'leads2',
                            minWidth: 75,
                            filterable: false,
                            show: !!titles.leads2GoalId,
                            accessor: d =>
                              d.leads2 !== null ? Number(d.leads2) : '-',
                            Cell: ({ value }) => {
                              return value !== '-' ? (
                                <span>{`${thousandSeparator(value)}`}</span>
                              ) : (
                                '-'
                              )
                            },
                          },
                          {
                            Header: 'Цена',
                            id: 'leads2Price',
                            filterable: false,
                            minWidth: 90,
                            show: !!titles.leads2GoalId,
                            accessor: d =>
                              d.leads2Price !== null
                                ? Number(d.leads2Price)
                                : '-',
                            Cell: ({ value }) => {
                              return value !== '-' ? (
                                <span>
                                  {`${thousandSeparator(value.toFixed(2))}`}
                                  <Rub width={8} height={8} className="rub" />
                                </span>
                              ) : (
                                '-'
                              )
                            },
                          },
                        ],
                      },
                      {
                        Header: 'Заявки',
                        columns: [
                          {
                            Header: 'Kонверсия\n в цель',
                            id: 'leads3Conversion',
                            filterable: false,
                            minWidth: 90,
                            show: !!titles.leads3GoalId,
                            accessor: d =>
                              d.leads3Conversion !== null
                                ? Number(d.leads3Conversion)
                                : '-',
                            Cell: ({ value }) => {
                              return value !== '-' ? (
                                <span>
                                  {`${thousandSeparator(
                                    Number(value).toFixed(2)
                                  )} %`}
                                </span>
                              ) : (
                                '-'
                              )
                            },
                          },
                          {
                            Header: 'Цель\n (кол-во)',
                            id: 'leads3',
                            minWidth: 75,
                            filterable: false,
                            show: !!titles.leads3GoalId,
                            accessor: d =>
                              d.leads3 !== null ? Number(d.leads3) : '-',
                            Cell: ({ value }) => {
                              return value !== '-' ? (
                                <span>{`${thousandSeparator(value)}`}</span>
                              ) : (
                                '-'
                              )
                            },
                          },
                          {
                            Header: 'Цена',
                            id: 'leads3Price',
                            filterable: false,
                            minWidth: 90,
                            show: !!titles.leads3GoalId,
                            accessor: d =>
                              d.leads3Price !== null
                                ? Number(d.leads3Price)
                                : '-',
                            Cell: ({ value }) => {
                              return value !== '-' ? (
                                <span>
                                  {`${thousandSeparator(value.toFixed(2))}`}
                                  <Rub width={8} height={8} className="rub" />
                                </span>
                              ) : (
                                '-'
                              )
                            },
                          },
                        ],
                      },
                      {
                        Header: 'Звонки',
                        columns: [
                          {
                            Header: 'Kонверсия\n в цель',
                            id: 'callsConversion',
                            filterable: false,
                            minWidth: 90,
                            show: !!titles.callsGoalId,
                            accessor: d =>
                              d.callsConversion !== null
                                ? Number(d.callsConversion)
                                : '-',
                            Cell: ({ value }) => {
                              return value !== '-' ? (
                                <span>
                                  {`${thousandSeparator(
                                    Number(value).toFixed(2)
                                  )} %`}
                                </span>
                              ) : (
                                '-'
                              )
                            },
                          },
                          {
                            Header: 'Цель\n (кол-во)',
                            id: 'calls',
                            minWidth: 75,
                            filterable: false,
                            show: !!titles.callsGoalId,
                            accessor: d =>
                              d.calls !== null ? Number(d.calls) : '-',
                            Cell: ({ value }) => {
                              return value !== '-' ? (
                                <span>{`${thousandSeparator(value)}`}</span>
                              ) : (
                                '-'
                              )
                            },
                          },
                          {
                            Header: 'Цена',
                            id: 'callsPrice',
                            filterable: false,
                            minWidth: 90,
                            show: !!titles.callsGoalId,
                            accessor: d =>
                              d.callsPrice !== null
                                ? Number(d.callsPrice)
                                : '-',
                            Cell: ({ value }) => {
                              return value !== '-' ? (
                                <span>
                                  {`${thousandSeparator(value.toFixed(2))}`}
                                  <Rub width={8} height={8} className="rub" />
                                </span>
                              ) : (
                                '-'
                              )
                            },
                          },
                        ],
                      },
                      {
                        Header: 'Звонки',
                        columns: [
                          {
                            Header: 'Kонверсия\n в цель',
                            id: 'calls2Conversion',
                            filterable: false,
                            minWidth: 90,
                            show: !!titles.calls2GoalId,
                            accessor: d =>
                              d.calls2Conversion !== null
                                ? Number(d.calls2Conversion)
                                : '-',
                            Cell: ({ value }) => {
                              return value !== '-' ? (
                                <span>
                                  {`${thousandSeparator(
                                    Number(value).toFixed(2)
                                  )} %`}
                                </span>
                              ) : (
                                '-'
                              )
                            },
                          },
                          {
                            Header: 'Цель\n (кол-во)',
                            id: 'calls2',
                            minWidth: 75,
                            filterable: false,
                            show: !!titles.calls2GoalId,
                            accessor: d =>
                              d.calls2 !== null ? Number(d.calls2) : '-',
                            Cell: ({ value }) => {
                              return value !== '-' ? (
                                <span>{`${thousandSeparator(value)}`}</span>
                              ) : (
                                '-'
                              )
                            },
                          },
                          {
                            Header: 'Цена',
                            id: 'calls2Price',
                            filterable: false,
                            minWidth: 90,
                            show: !!titles.calls2GoalId,
                            accessor: d =>
                              d.calls2Price !== null
                                ? Number(d.calls2Price)
                                : '-',
                            Cell: ({ value }) => {
                              return value !== '-' ? (
                                <span>
                                  {`${thousandSeparator(value.toFixed(2))}`}
                                  <Rub width={8} height={8} className="rub" />
                                </span>
                              ) : (
                                '-'
                              )
                            },
                          },
                        ],
                      },
                      {
                        Header: 'Звонки',
                        columns: [
                          {
                            Header: 'Kонверсия\n в цель',
                            id: 'calls3Conversion',
                            filterable: false,
                            minWidth: 90,
                            show: !!titles.calls3GoalId,
                            accessor: d =>
                              d.calls3Conversion !== null
                                ? Number(d.calls3Conversion)
                                : '-',
                            Cell: ({ value }) => {
                              return value !== '-' ? (
                                <span>
                                  {`${thousandSeparator(
                                    Number(value).toFixed(2)
                                  )} %`}
                                </span>
                              ) : (
                                '-'
                              )
                            },
                          },
                          {
                            Header: 'Цель\n (кол-во)',
                            id: 'calls3',
                            minWidth: 75,
                            filterable: false,
                            show: !!titles.calls3GoalId,
                            accessor: d =>
                              d.calls3 !== null ? Number(d.calls3) : '-',
                            Cell: ({ value }) => {
                              return value !== '-' ? (
                                <span>{`${thousandSeparator(value)}`}</span>
                              ) : (
                                '-'
                              )
                            },
                          },
                          {
                            Header: 'Цена',
                            id: 'calls3Price',
                            filterable: false,
                            minWidth: 90,
                            show: !!titles.calls3GoalId,
                            accessor: d =>
                              d.calls3Price !== null
                                ? Number(d.calls3Price)
                                : '-',
                            Cell: ({ value }) => {
                              return value !== '-' ? (
                                <span>
                                  {`${thousandSeparator(value.toFixed(2))}`}
                                  <Rub width={8} height={8} className="rub" />
                                </span>
                              ) : (
                                '-'
                              )
                            },
                          },
                        ],
                      },
                      {
                        Header: 'Продажи',
                        columns: [
                          {
                            Header: 'Kонверсия\n в продажу',
                            id: 'ordersConversion',
                            filterable: false,
                            minWidth: 90,
                            accessor: d =>
                              d.ordersConversion !== null
                                ? Number(d.ordersConversion)
                                : '-',
                            Cell: ({ value }) => {
                              return value !== '-' ? (
                                <span>
                                  {`${thousandSeparator(
                                    Number(value).toFixed(2)
                                  )} %`}
                                </span>
                              ) : (
                                '-'
                              )
                            },
                          },
                          {
                            Header: 'Кол-во',
                            id: 'orders',
                            minWidth: 75,
                            filterable: false,
                            accessor: d =>
                              d.orders !== null ? Number(d.orders) : '-',
                            Cell: ({ value }) => {
                              return value !== '-' ? (
                                <span>{`${thousandSeparator(value)}`}</span>
                              ) : (
                                '-'
                              )
                            },
                          },
                          {
                            Header: 'Выручка',
                            id: 'revenue',
                            filterable: false,
                            minWidth: 90,
                            accessor: d =>
                              d.revenue !== null ? Number(d.revenue) : '-',
                            Cell: ({ value }) => {
                              return value !== '-' ? (
                                <span>
                                  {`${thousandSeparator(value.toFixed(2))}`}
                                  <Rub width={8} height={8} className="rub" />
                                </span>
                              ) : (
                                '-'
                              )
                            },
                          },
                          {
                            Header: 'CPO',
                            id: 'cpo',
                            filterable: false,
                            minWidth: 90,
                            accessor: d =>
                              d.cpo !== null ? Number(d.cpo) : '-',
                            Cell: ({ value }) => {
                              return value !== '-' ? (
                                <span>
                                  {`${thousandSeparator(value.toFixed(2))}`}
                                  <Rub width={8} height={8} className="rub" />
                                </span>
                              ) : (
                                '-'
                              )
                            },
                          },
                          {
                            Header: 'ROMI',
                            id: 'romi',
                            filterable: false,
                            resizable: false,
                            minWidth: 75,
                            accessor: d =>
                              d.romi !== null ? Number(d.romi) : '-',
                            Cell: ({ value }) => {
                              return value !== '-' ? (
                                <span>
                                  {`${thousandSeparator(
                                    Number(value).toFixed(2)
                                  )} %`}
                                </span>
                              ) : (
                                '-'
                              )
                            },
                          },
                        ],
                      },
                    ]}
                  />
                )
              }}
              className="subTable"
            />
          )
        }}
        className="subTable"
      />
    )
  }
}

export default withStyles(styles)(MTableAdvancedDemo)
